// 设置管理员页面访问标志
export const setAdminAccessFlag = (value: boolean) => {
	sessionStorage.setItem('isAdminAccessed', value.toString())
}

// 获取管理员页面访问标志
export const getAdminAccessFlag = () => {
	return sessionStorage.getItem('isAdminAccessed') === 'true'
}

// 清除管理员页面访问标志
export const clearAdminAccessFlag = () => {
	sessionStorage.removeItem('isAdminAccessed')
}
